class KpiAssignmentsModel {
  constructor({
    kpiAssignmentsId = null,
    kpiNameId = null,
    jobId = null,
    branchId = null,
    kpiCode = null,
    primaryAssessorId = null,
    weight = null,
    publish = null,
    frequency = "",
    accountability = "",
    target = null,
    perspectiveId = null,
    source = "",
    from = null,
    to = null,
    createdAt = new Date(),
    secondaryAssessorId = null,
    primaryPercentage = 100,
    description = "",
    primaryAssessorUId,
    secondaryAssessorUId,
  } = {}) {
    this.kpiAssignmentsId = kpiAssignmentsId;
    this.kpiNameId = kpiNameId;
    this.jobId = jobId;
    this.kpiCode = kpiCode;
    this.primaryAssessorId = primaryAssessorId;
    this.weight = weight;
    this.publish = publish;
    this.frequency = frequency;
    this.accountability = accountability;
    this.target = target;
    this.perspectiveId = perspectiveId;
    this.source = source;
    this.from = from ? new Date(from) : null;
    this.to = to ? new Date(to) : null;
    this.createdAt = createdAt ? new Date(createdAt) : new Date();
    this.secondaryAssessorId = secondaryAssessorId;
    this.branchId = branchId;
    this.primaryPercentage = primaryPercentage;
    this.description = description;
    this.primaryAssessorUId = primaryAssessorUId;
    this.secondaryAssessorUId = secondaryAssessorUId;
  }
}

export default KpiAssignmentsModel;
